"use client";

import { SafeHydrate } from "@/SafeHydrate";
import * as React from "react";
import { Quote } from "lucide-react";
import { cn } from "@/lib/utils";
import { Carousel, CarouselContent, CarouselItem, type CarouselApi } from "@/components/ui/carousel";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { Button } from "@/components/ui/button";
const testimonials = [{
  quote: "Benchmark's data-driven strategy redefined our market position and doubled our ROI within six months.",
  author: "Marcus Thorne",
  position: "CEO, Aether Logistics",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661389/img/marcus_thorne_executive.png"
}, {
  quote: "The architectural precision of their media planning is unlike anything we've seen in the advertising space.",
  author: "Elena Rodriguez",
  position: "Marketing Director, Vertex Tech",
  avatar: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1661389/img/elena_rodriguez_director.png"
}];
export default function ClinicalSuccessStories() {
  const [api, setApi] = React.useState<CarouselApi>();
  const [current, setCurrent] = React.useState(0);
  const [count, setCount] = React.useState(0);
  React.useEffect(() => {
    if (!api) {
      return;
    }
    setCount(api.scrollSnapList().length);
    setCurrent(api.selectedScrollSnap());
    api.on("select", () => {
      setCurrent(api.selectedScrollSnap());
    });
  }, [api]);
  return <section data-section-id="223270" id="client-success-stories" className="bg-background text-foreground relative overflow-hidden py-24 sm:py-32">
      {}
      <div className="absolute top-0 right-0 -mr-40 -mt-40 size-[500px] rounded-full bg-primary/10 blur-[120px] animate-pulse pointer-events-none" />
      <div className="absolute bottom-0 left-0 -ml-40 -mb-40 size-[500px] rounded-full bg-chart-3/10 blur-[120px] animate-pulse pointer-events-none" style={{
      animationDelay: "2s"
    }} />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="mb-16 text-center">
          <h2 className="text-sm font-default font-bold tracking-widest text-primary uppercase mb-3">
            Client Success Stories
          </h2>
          <p className="text-3xl sm:text-4xl font-default font-black text-foreground tracking-tighter">
            The Gold Standard of Results
          </p>
        </div>

        <div className="max-w-5xl mx-auto">
          <Carousel setApi={setApi} opts={{
          align: "center",
          loop: true
        }} className="w-full">
            <CarouselContent>
              {testimonials.map((item, i) => <CarouselItem data-index={i} key={i}>
                  <div className="flex flex-col items-center text-center px-4 sm:px-12 py-8">
                    <Quote className="size-10 sm:size-14 text-primary/30 mb-8 shrink-0" />
                    
                    <p className="text-2xl sm:text-4xl md:text-5xl font-serif italic font-light tracking-tight text-foreground mb-12 leading-snug sm:leading-tight">
                      "{item.quote}"
                    </p>
                    
                    <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6 bg-white/5 backdrop-blur-md border border-white/10 rounded-lg p-4 sm:pr-8 sm:pl-4 shadow-2xl transition-all duration-500 hover:bg-white/10">
                      <SafeHydrate><Avatar className="size-16 sm:size-20 border-2 border-primary/40 shadow-lg">
                        <AvatarImage src={item.avatar} alt={item.author} className="grayscale hover:grayscale-0 transition-all duration-500" />
                        <AvatarFallback className="bg-primary/20 text-primary font-default text-xl">
                          {item.author.charAt(0)}
                        </AvatarFallback>
                      </Avatar></SafeHydrate>
                      <div className="text-center sm:text-left">
                        <div className="font-default font-bold text-lg text-foreground tracking-tight">
                          {item.author}
                        </div>
                        <div className="text-muted-foreground text-sm font-mono uppercase tracking-wider">
                          {item.position}
                        </div>
                      </div>
                    </div>
                  </div>
                </CarouselItem>)}
            </CarouselContent>
          </Carousel>

          {}
          <div className="flex justify-center items-center gap-6 mt-12">
            {Array.from({
            length: count
          }).map((_, i) => <Button key={i} data-index={i} variant="ghost" size="icon" onClick={() => api?.scrollTo(i)} className={cn("size-10 rounded-none relative flex items-center justify-center transition-all duration-500 hover:bg-transparent", current === i ? "text-primary" : "text-muted-foreground/30 hover:text-primary/60")} aria-label={`Go to slide ${i + 1}`}>
                {}
                <div className="absolute w-full h-[1px] bg-current transition-colors duration-300" />
                <div className="absolute h-full w-[1px] bg-current transition-colors duration-300" />
                
                {}
                <div className={cn("absolute size-2 rounded-none bg-current transition-all duration-500 shadow-[0_0_10px_rgba(45,91,255,0.5)]", current === i ? "scale-100 opacity-100" : "scale-0 opacity-0")} />
              </Button>)}
          </div>
        </div>
      </div>
    </section>;
}